var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 512,
    height: 341.326,
    y: 85.337
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052b4"
    },
    width: 512,
    height: 113.775,
    y: 199.112
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#d80027"
    },
    width: 512,
    height: 113.775,
    y: 312.888
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M233.606,196.639v14.837c0,34.081-44.522,44.522-44.522,44.522s-44.522-10.44-44.522-44.522v-14.837 l-0.145-44.188l89.043-0.266L233.606,196.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052b4"
    },
    d: "M233.606,196.639v14.837c0,34.081-44.522,44.522-44.522,44.522s-44.522-10.44-44.522-44.522v-14.837 l-0.145-44.188l89.043-0.266L233.606,196.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0"
    },
    d: "M233.606,196.639v14.837c0,34.081-44.522,44.522-44.522,44.522s-44.522-10.44-44.522-44.522v-14.837 l14.848,14.837l29.674-22.261l29.685,22.261L233.606,196.639z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlv);
export default __webpack_public_path__ + "static/media/slv.9cda21815dbd39b497f019aef5534995.svg";
export { ForwardRef as ReactComponent };